<template>
    <div>
        <CCardBody>
            <div class="text-right btngroup">
                <CButton class="addBtn" @click="showModal('permissions')">
                    create
                </CButton>
            </div>
            <search-items v-model="search" :searchHandler="searchPermission"
                :placeholder="'Type to search'"></search-items>
            <b-table :items="permissions" :fields="headers" hover sorter>
                <template #cell(actions)="item">
                    <delete class="delete_role ml-2" @click="deletePermission(item.item)" fillColor="#E30000" />
                    <Pencil class="edit_role" @click="editPermission(item.item)" fillColor="#009FE3" />
                </template>
            </b-table>
            <b-pagination v-model="pagination.currentPage" :total-rows="pagination.rows" :per-page="pagination.perPage"
                aria-controls="itemList" align="center" @change="handlePagination" v-if="pagination.total > 0"
                :key="pagination.currentPage"></b-pagination>
            <b-modal ref="permission-modal" @hidden="clearForm" id="permissionsModal" size="lg" no-close-on-backdrop
                hide-footer>
                <template #modal-title>
                    <span>{{ isUpdating ? 'Edit' : 'Add' }} Permission</span>
                </template>
                <div class="row">
                    <div class="col-sm-6">
                        <b-form-group label="Is Menu?" label-for="input-1">
                            <b-form-checkbox value="1" v-model="form.is_menu" unchecked-value="0"></b-form-checkbox>
                        </b-form-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label for="" class="required">Permission Name</label>
                        <b-form-group>
                            <b-form-input v-validate="{ required: true }" class="form-input" type="text" name="name"
                                v-model="form.name">
                            </b-form-input>
                            <div v-if="errors && errors.first('name')" class="error_msg">
                                Permission name is required
                            </div>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <label for="" class="required">Label</label>
                        <b-form-group>
                            <b-form-input v-validate="{ required: true }" class="form-input" type="text" name="label"
                                v-model="form.label"></b-form-input>
                            <div v-if="errors && errors.first('label')" class="error_msg">
                                Label is required
                            </div>
                        </b-form-group>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-6">
                        <label for="" class="required">Select Routes</label>
                        <v-select autocomplete="off" class="form-input" :options="routes" name="route" multiple
                            placeholder="Select Routes" v-model="form.selected_routes">
                        </v-select>
                    </div>
                    <div class="col-sm-6">
                        <label for="" class="required">Select Icons</label>
                        
                       <v-select
                            class="form-input"
                            :options="filteredIcons"
                            v-model="form.icon"
                            placeholder="Select Icon"
                            @search="iconSearch = $event"
                            >
                            <template #option="{name}">
                                <span v-if="name" style="display: flex; align-items: center; gap:5px">
                                    <component :is="name" :size="24" class="icon-svg" />
                                        {{ name }}
                                </span>
                                </template>
                        </v-select>
                        <component :is="icons.find(i => i.name === form.icon)?.component" v-if="form.icon" :size="32" />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-8">
                        <label for="" class="required">Select Module</label>
                        <v-select v-validate="{ required: true }" autocomplete="off" class="form-input"
                            :options="modules" name="module" v-model="form.p_module">
                        </v-select>
                        <div v-if="errors && errors.first('module')" class="error_msg">
                            Module name is required
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <label for="" style="visibility:hidden">input</label>
                        <b-form-group label-for="input-1">
                            <b-button size="md" widt="300px" @click="showModal('module')"
                                class="btn btn-secondary btn-block form-input"> +Module</b-button>
                        </b-form-group>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12">
                        <b-form-textarea id="textarea" v-model="form.description" placeholder="Enter Description"
                            rows="2"></b-form-textarea>
                    </div>
                </div>

                <div class="row  mt-3">
                    <div class="col-sm-5">
                        <label for="" class="required">Select Application Type</label>
                        <b-form-select class="mt-3" name="app_type" v-validate="{ required: true }"
                            v-model="form.app_type" :options="appTypeOptions"></b-form-select>
                        <div v-if="errors && errors.first('app_type')" class="error_msg">
                            Application type field is required
                        </div>
                    </div>
                </div>

                <div class="row  mt-3">
                    <div class="col-sm-5">
                        <label for="" class="required">Select Permission Type</label>
                        <v-select autocomplete="off" class="form-input" :options="permission_type" name="role"
                            v-model="form.permission_type">
                        </v-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <label for="" class="required">Select Parent label</label>
                        <v-select autocomplete="off" class="form-input" :options="parent_labels" name="role"
                            v-model="form.parent_label">
                        </v-select>
                    </div>
                    <div class="col-sm-5 ml-2" v-if="form.permission_type == 'Url'">
                        <label for="" class="required">Path</label>
                        <b-form-group>
                            <b-form-input v-validate="form.permission_type == 'Url' ? { required: true } : ''"
                                class="form-input" type="text" name="url" v-model="form.url_path"></b-form-input>
                            <div v-if="errors && errors.first('url')" class="error_msg">
                                url path is required
                            </div>
                        </b-form-group>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-6">
                        <b-button class="btn btn-lg btn-success float-right  form-input" @click="savePermissions"> Save
                        </b-button>
                    </div>
                    <div class="col-sm-6">
                        <b-button class="btn btn-lg btn-secondary  float-left form-input" @click="closeModal"> Cancel
                        </b-button>
                    </div>
                </div>
            </b-modal>
            <b-modal id="moduleModal" size="md" no-close-on-backdrop hide-footer>
                <template #modal-title>
                    <span> Add Module </span>
                </template>
                <div class="row">
                    <div class="col-md-12">
                        <label for="" class="required">Module Name</label>
                        <b-form-group>
                            <b-form-input v-validate="'required|alpha_num'" class="form-input" type="text"
                                name="mod_name" v-model="mod_name"></b-form-input>
                        </b-form-group>
                        <div v-for="error in errors.collect('mod_name')" :key="error" class="error_msg">
                            {{ error }}
                        </div>
                    </div>
                </div>
                <div class="row mt-3 justify-content-center">
                    <b-button size="md" class="btn btn-secondary  form-input" @click="savemodule"> Save </b-button>
                </div>
            </b-modal>
        </CCardBody>
    </div>
</template>
<script>
import Pencil from 'vue-material-design-icons/GreasePencil.vue';
import Delete from 'vue-material-design-icons/Delete.vue';
import myMixins from '@/mixins/myMixins';
import { getPageModal, removePageModal, setPageModal, getLastPage } from "@/helpers/Helpers";
import SearchItems from '@/components/SearchItems.vue';
import { http } from '@/config/httpCommon';
import * as lucideIcons from 'lucide-vue'

export default {
    mixins: [myMixins],
    components: {
        Delete,
        Pencil,
        SearchItems,
        
    },
    data() {
        return {
            modules: [],
            mod_name: '',
            urlState: false,
            isUpdating: false,
            roleModal: false,
            name: '',
            id: '',
            permissions: [],
            parent_labels: [{ id: '0', label: 'Please select parent label' }],
            permission_type: ['Url', 'Label'],
            form: {
                id: '',
                name: '',
                label: '',
                is_menu: 0,
                icon: '',
                p_module: '',
                app_type: '',
                permission_type: '',
                parent_label: '',
                description: '',
                url_path: '',
                selected_routes: []
            },
            appTypeOptions: [
                { text: 'Please select a type', value: '' },
                { text: 'Admin', value: 'admin' },
                { text: 'Frontend', value: 'customizer' }
            ],
            headers: [
                { key: 'name', label: 'Permission Name', sortable: true },
                { key: 'label', label: 'Label', sortable: true },
                { key: 'module_name', label: 'Module', sortable: true },
                { key: 'is_menu', label: 'Is Menu?', sortable: true },
                { key: 'actions', label: 'Actions', },
            ],
            pagination: {
                rows: null,
                currentPage: null,
                perPage: null,
                total: 0
            },
            search: '',
            icons: [],
            iconSearch: '',
            routes: []
        }
    },
    computed: {
        filteredIcons() {
            if (!this.iconSearch) {
                // Show first 15 icons if no search
                return this.icons.slice(0, 15)
            }
            // Filter icons by search and show up to 15 matches
            const search = this.iconSearch.toLowerCase()
            return this.icons
                .filter(icon => icon.name.toLowerCase().includes(search))
                .slice(0, 15)
        }
    },
    async created() {
        this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getPermissions)
        this.$store.commit('set', ['showLoader', true]);
        await this.$store.dispatch("getmodules");
        await this.$store.dispatch('getparentlabel');
        this.modules = this.$store.getters.getModules;
        this.parent_labels = this.$store.getters.getparentlabels;
        this.$store.commit('set', ['showLoader', false]);
        http.get("routes").then(res => {
            this.routes = res.data.result;
        })
        this.icons = Object.keys(lucideIcons.icons).map(iconName => {
        return {
          name: iconName,
          label: iconName,
          id:iconName
        }})
    },
    methods: {
        showModal(name) {
            if (name == 'module') {
                this.$bvModal.show("moduleModal");
            }
            if (name == 'permissions') {
                this.$bvModal.show("permissionsModal");
            }
        },
        async getPermissions(params) {
            let res = await this.$store.dispatch('getpermissions', params);
            this.permissions = this.$store.getters.getpermissions;
            this.makePagination(res.data);
        },
        makePagination(data) {
            this.pagination.currentPage = data.current_page;
            this.pagination.rows = data.total;
            this.pagination.perPage = data.per_page;
            this.pagination.total = data.total;
        },
        async handlePagination(page = '') {
            let params = '?page=' + page;
            if (this.search) {
                params += '&search=' + this.search
            }
            setPageModal(page, this.$route.name, this.search);
            this.getPermissions(params);
        },
        searchPermission() {
            let params = ''
            if (this.search) {
                params = '?search=' + this.search;
            }
            setPageModal(1, this.$route.name, this.search);
            this.getPermissions(params);
        },
        async savePermissions() {
            let valid = await this.$validator.validate();
            let res = '';
            if (valid) {
                if (this.isUpdating == false) {
                    res = await this.$store.dispatch('savepermission', this.form);
                } else if (this.isUpdating == true) {
                    res = await this.$store.dispatch('updatepermission', this.form);
                }
                if (res.status == 201) {
                    this.permissions = this.$store.getters.getpermissions;
                    if (this.isUpdating === false) {
                        this.nextPageOnCreation('page', 'search', this.permissions.length, this.pagination.perPage, this.pagination.currentPage, getLastPage(this.pagination.perPage, this.pagination.total), this.$route.name, this.getPermissions);
                    }
                    else if (this.isUpdating === true) {
                        this.preservePagination('page', 'search', this.$route.name, this.getPermissions)
                    }

                    this.clearForm();
                    this.$bvModal.hide("permissionsModal");
                    this.showToast(res.data.message, "SUCCESS");
                }
            }
        },
        async savemodule() {
            let data = await this.$store.dispatch('addmodule', { name: this.mod_name });
            if (data.status == 200) {
                this.mod_name = '';
                this.$bvModal.hide("moduleModal");
                this.showToast(data.data.message, "SUCCESS");
            }
        },
        async editPermission(item) {
            this.form.id = item.id;
            let parent_label = this.parent_labels.filter(label => {
                if (label.id == item.parent_menu_id) {
                    return {
                        id: label.id,
                        label: label.label
                    }
                }
            });
            this.isUpdating = true;
            this.form.name = item.name;
            this.form.label = item.label;
            if (item.is_menu == "Yes") {
                this.form.is_menu = 1;
            }
            else {
                this.form.is_menu = 0;
            }
            this.form.icon = item.icon_id;
            this.form.p_module = { id: item.module && item.p_module ? item.p_module.id : '', label: item.module ? item.module.module_name : '' };
            this.form.app_type = item.app_type;
            this.form.permission_type = item.type.charAt(0).toUpperCase() + item.type.slice(1);
            this.form.parent_label = parent_label[0];
            this.form.description = item.description;
            this.form.url_path = item.url_path;
            if (item.routes && item.routes.length > 0) {
                this.routes.forEach(route => {
                    if (item.routes.includes(route.name)) {
                        this.form.selected_routes.push(route);
                    }
                });
            }

            this.showModal('permissions');
        },
        clearForm() {
            this.form.id = '';
            this.form.name = '';
            this.form.label = '';
            this.form.is_menu = 0;
            this.form.icon = '';
            this.form.p_module = '';
            this.form.permission_type = '';
            this.form.parent_label = '';
            this.form.description = '';
            this.form.url_path = '';
            this.isUpdating = false;
            this.form.selected_routes = [];
        },
        async deletePermission(item) {
            var cnf = confirm("are you sure you want to delete this permission");
            if (cnf == true) {
                let res = await this.$store.dispatch('deletepermission', item.id);
                if (res.status == 204) {
                    await this.$store.dispatch("getnavigation");
                    this.permissions = this.$store.getters.getpermissions;
                    this.previousPageOnDeletion('page', 'search', this.permissions.length - 1, this.$route.name, this.getPermissions);
                    this.showToast("Permission deleted successfully", "SUCCESS");
                }
            }
        },
        closeModal() {
            this.$refs['permission-modal'].hide()
        }
    },
}
</script>
<style type="scss">
.delete_role {
    cursor: pointer;
}

.edit_role {
    cursor: pointer;
}

.form-input {
    border-radius: 1px;
}

.save-btn {}
</style>